import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Lamina1 from "./pages/Lamina1";
import Lamina2 from "./pages/Lamina2";
import Lamina3 from "./pages/Lamina3";
import Lamina4 from "./pages/Lamina4";
import Lamina5 from "./pages/Lamina5";
import Lamina6 from "./pages/Lamina6";
import Lamina7 from "./pages/Lamina7";
import Lamina8 from "./pages/Lamina8";
import Lamina9 from "./pages/Lamina9";
import Lamina10 from "./pages/Lamina10";
import Lamina11 from "./pages/Lamina11";
import Lamina12 from "./pages/Lamina12";
import Lamina13 from "./pages/Lamina13";
import Lamina14 from "./pages/Lamina14";
import Lamina15 from "./pages/Lamina15";
import Lamina16 from "./pages/Lamina16";
import Lamina17 from "./pages/Lamina17";
import Lamina18 from "./pages/Lamina18";
import Lamina19 from "./pages/Lamina19";
import Lamina20 from "./pages/Lamina20";
import Lamina21 from "./pages/Lamina21";
import Lamina22 from "./pages/Lamina22";
import Lamina23 from "./pages/Lamina23";
import Lamina24 from "./pages/Lamina24";
import Lamina25 from "./pages/Lamina25";
import Lamina26 from "./pages/Lamina26";
import Lamina27 from "./pages/Lamina27";
import Lamina28 from "./pages/Lamina28";

import Scroll from "./components/Scroll";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ef4136",
    },
    secondary: {
      main: "#ffcb05",
    },
    purple: {
      main: "#6a2c91",
    },
    blue: {
      main: "#0072bc",
    },
    green: {
      main: "#00a77e",
    },
  },
});

/**
 * Función inicial donde se incluyen las rutas de las páginas
 * @return {React.ReactElement} Rutas de la app
 */
function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router basename={"especiales/ciudadania-activa/"}>
        <Scroll>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/lamina-1-1">
              <Lamina1 />
            </Route>
            <Route exact path="/lamina-1-2">
              <Lamina2 />
            </Route>
            <Route exact path="/lamina-1-3">
              <Lamina3 />
            </Route>
            <Route exact path="/lamina-1-4">
              <Lamina4 />
            </Route>
            <Route exact path="/lamina-1-5">
              <Lamina5 />
            </Route>
            <Route exact path="/lamina-1-6">
              <Lamina6 />
            </Route>
            <Route exact path="/lamina-1-7">
              <Lamina7 />
            </Route>
            <Route exact path="/lamina-1-8">
              <Lamina8 />
            </Route>
            <Route exact path="/lamina-1-9">
              <Lamina9 />
            </Route>
            <Route exact path="/lamina-1-10">
              <Lamina10 />
            </Route>
            <Route exact path="/lamina-1-11">
              <Lamina11 />
            </Route>
            <Route exact path="/lamina-1-12">
              <Lamina12 />
            </Route>
            <Route exact path="/lamina-1-13">
              <Lamina13 />
            </Route>
            <Route exact path="/lamina-1-14">
              <Lamina14 />
            </Route>
            <Route exact path="/lamina-1-15">
              <Lamina15 />
            </Route>
            <Route exact path="/lamina-1-16">
              <Lamina16 />
            </Route>
            <Route exact path="/lamina-1-17">
              <Lamina17 />
            </Route>
            <Route exact path="/lamina-1-18">
              <Lamina18 />
            </Route>
            <Route exact path="/lamina-1-19">
              <Lamina19 />
            </Route>
            <Route exact path="/lamina-1-20">
              <Lamina20 />
            </Route>
            <Route exact path="/lamina-1-21">
              <Lamina21 />
            </Route>
            <Route exact path="/lamina-1-22">
              <Lamina22 />
            </Route>
            <Route exact path="/lamina-1-23">
              <Lamina23 />
            </Route>
            <Route exact path="/lamina-1-24">
              <Lamina24 />
            </Route>
            <Route exact path="/lamina-1-25">
              <Lamina25 />
            </Route>
            <Route exact path="/lamina-1-26">
              <Lamina26 />
            </Route>
            <Route exact path="/lamina-1-27">
              <Lamina27 />
            </Route>
            <Route exact path="/lamina-1-28">
              <Lamina28 />
            </Route>
          </Switch>
          <Footer />
        </Scroll>
      </Router>
    </ThemeProvider>
  );
}

export default App;
